import { type AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

export type BridgeRecord = {
	bridgeActivityId: number
	activityType: string
	activityName: string
	createDate: string
}

export class BridgeQueryClient {
	constructor(private axiosClient: AxiosInstance) {}

	public getBridgeRecords = () =>
		handleQueryResult(
			this.axiosClient.get<BridgeRecord[]>(
				`/api/admin/integrations/bridge/records`
			)
		)

	public deleteAllBridgeRecords = async () =>
		handleQueryResult(
			this.axiosClient.delete<void>(
				`/api/admin/integrations/bridge/records`
			)
		)

	public deleteBridgeRecord = (bridgeActivityId: number) =>
		handleQueryResult(
			this.axiosClient.delete<void>(
				`/api/admin/integrations/bridge/record/${bridgeActivityId}`
			)
		)
}
